import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingStates: { [key: string]: BehaviorSubject<boolean> } = {};

  setLoading(apiName: string, isLoading: boolean) {
    if (!this.loadingStates[apiName]) {
      this.loadingStates[apiName] = new BehaviorSubject<boolean>(false);
    }
    this.loadingStates[apiName].next(isLoading);
  }

  getLoadingState(apiName: string) {
    if (!this.loadingStates[apiName]) {
      this.loadingStates[apiName] = new BehaviorSubject<boolean>(false);
    }
    return this.loadingStates[apiName].asObservable();
  }
}
